import { ReactNode } from 'react'
import { Sidebar } from './Sidebar'

interface DashboardLayoutProps {
  children: ReactNode
  onNewSubmission?: () => void
}

export function DashboardLayout({ children, onNewSubmission }: DashboardLayoutProps) {
  return (
    <div className="flex h-screen bg-background">
      <Sidebar onNewSubmission={onNewSubmission} />
      <main className="flex-1 overflow-auto">
        {children}
      </main>
    </div>
  )
}
